<template>
  <div>
    <div class="menu" id="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item>
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="contenter">
      <div class="title">
        <span class="el-icon-document"></span>
        <span>News & Updates</span>
      </div>
      <h1 class="newsTitle">金银花基因组揭示动态花色中类胡萝卜素代谢的分子机制</h1>
      <div class="des">
        本研究首次报道了川续断目植物——金银花的染色体水平基因组，为分子育种提供了宝贵的遗传资源，也为金银花家族的进化提供了重要线索。通过基因组与转录组分析相结合，阐明了金银花中动态花色的形成机制。
      </div>
      <div class="img">
        <img src="../../assets/news3_1.png" width="60%" />
      </div>
      <div class="des1">
        <strong>标题：</strong>The honeysuckle genome provides insight into the molecular mechanism of carotenoid metabolism underlying dynamic flower coloration<br />
        <strong>研究团队：</strong
        >中国医学科学院药用植物研究所宋经元研究员、徐志超副研究员团队、中国中医科学院中药研究所、美国爱荷华州立大学及比利时根特大学的相关研究人员<br />
        <strong>期刊：</strong>New Phytologist（IF：7.299）<br />
        <strong>研究背景：</strong><br />
        <div class="textindent">
         金银花（Lonicera japonica）是忍冬科的代表种，具有很高的药用价值，用于治疗发烧、流感，同时具有抗病毒活性，如抗SARS、甲型流感病毒、H1N1等。金银花具有动态的花色，单株花在发育过程中会逐渐从白色变成金色，具有很高的观赏价值。目前有转录组集中研究金银花药物活性物质的生物合成，但是记录花颜色变化的分子机制尚未揭示。有报道显示类胡萝卜素的变化导致金银花花色变化，但其在金银花显色过程中的分子调控机制还不清楚。
        </div>
        <strong>主要研究内容：</strong><br />
        1.基因组组装及注释<br />
        <div class="textindent">
          通过Nanopore、Illumina和Hi-C测序相结合，获得843.2Mb的金银花基因组，杂合度1.27%，contig N50为2.1Mb，Scaffold N50为84.4Mb，共注释3396个编码基因，重复序列为58.21%。
        </div>
        <div class="img">
          <img src="../../assets/news3_2.png" width="60%" />
        </div>
        <div class="des1">
          2.金银花系统发育和全基因组复制事件<br />
          <div class="textindent">
            基因家族收缩和扩张分析显示，有3133个基因家族发生扩张，7397个基因家族发生收缩，扩张的基因家族在催化活性（GO:0003824）和代谢过程（GO:0008152）中得到富集。基于13种植物，169个单拷贝基因进行系统发育分析，发现金银花与菊花、莴苣的亲缘关系最为密切,与菊花分化时间为87Ma。
          </div>
           <div class="textindent">
            金银花基因组与重建的祖先双子叶植物核型（AEK）及葡萄基因组的比较，发现金银花物种形成后发生了显著的染色体重排和全基因组复制事件；与菊花、莴苣和咖啡的Ks分布分析显示复制发生在其与菊科分离后约51Ma。
          </div>
        </div>
        <div class="img">
          <img src="../../assets/news3_3.png" width="60%" />
        </div>
        <div class="des1">
          3.花发育不同阶段类胡萝卜素的积累<br />
          <div class="textindent">
            类胡萝卜素浓度随着花的成熟而先降低后急剧增加，特别是从银色花SF到金色花GF花期，类胡萝卜素浓度增加了三倍。UPLC检测发现：叶黄素和β-胡萝卜素是不同花发育阶段的两种主要化合物。通过加权基因共表达网络分析（WGCNA）将不同花期样品的13891个高表达基因（FPKM>10）分为15个模块。模块-性状关系显示221基因coral1模块与类胡萝卜素含量高度相关，且模块‘coral1’和‘firebrick4’的所选基因在芳香化合物生物合成途径和基因表达调控（GO:0019438和GO:0010468)中富集。
          </div>
        </div>
         <div class="img">
          <img src="../../assets/news3_4.png" width="60%" />
        </div>
         <div class="des1">
          4.胡萝卜素合成基因的进化与表达分析<br />
          <div class="textindent">
           基于已知的类胡萝卜素生物合成通路进行金银花中类胡萝卜素生物合成基因的研究，研究发现PSY基因在金银花中扩张成一个小的基因家族，LjPSY1和LjPSY3同源基因可能是金银花WGD事件的产物。LjPSY1、LjPDS1和LjPDS3在SF-TWF期显著高表达，将无色的植物烯转化为红色的番茄红素。番茄红素在LCYE和LCYB催化下逐步转化为β-胡萝卜素、叶黄素；NCED3基因家族在ABA生物合成中起着关键作用，导致产生TWF的枯萎过程。作者随后通过qPCR验证了表达量的准确性，说明了金银花WGD事件对类胡萝卜素生物合成存在影响。转录组和类胡萝卜素含量分析进一步表明，β-胡萝卜素积累在金银花动态花色形成中起主要作用。
          </div>
        </div>
         <div class="img">
          <img src="../../assets/news3_5.png" width="60%" />
        </div>

        <div class="des1">
          5.花色中类胡萝卜素裂解双加氧酶(CCD)的进化及功能鉴定<br />
          <div class="textindent">
           CCD家族通常催化类胡萝卜素裂解。全基因组的分析鉴定出7个CCD基因，5个亚家族，其中LjCCD4 和 LjCCD1b表达量比较高。对LjCCD4 和 LjCCD1b进行功能验证，将LjCCD4 和 LjCCD1b序列克隆到pET32a载体中，然后将表达载体导入大肠杆菌BL21(DE3)，通过UPLC、GC-MS和LC-MS检测发现LjCCD4 和 LjCCD1b表达蛋白可将β-胡萝卜素、叶黄素和100-apo-β-胡萝卜素转化为无色和挥发性物质导致颜色发生变化。同时产物中含有植物-传粉者相互作用中的挥发性信号。
          </div>
        </div>
        <div class="img1">
            <div>
               <img src="../../assets/news3_6.png" width="50%" />
               <img src="../../assets/news3_7.png" width="50%" />
            </div>
        </div>
         <div class="des1">
            <strong>研究意义：</strong><br />
            <div class="textindent">
              本研究首次报道了川续断目植物——金银花的染色体水平基因组，通过基因组与转录组分析相结合，阐明了金银花中动态花色的形成机制，为分子育种提供了宝贵的遗传资源，也为金银花家族的进化提供了重要线索。
            </div>
         </div>
      </div>
    </div>
  </div>
</template>
<script>
import Species from "../page/Species.vue";
export default {
  components: { Species },
  created(){
    window.addEventListener("scroll", this.handleScroll);
  },
  methods:{
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
  }
};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.contenter {
  width: 1140px;
  margin: 0 auto;
  /* height: 500px; */
  box-shadow: 0 0 10px #bbb;
  padding: 0 30px;
  background: #fff;
  min-height: 500px;
}
.contenter .newsTitle {
  text-align: center;
  line-height: 30px;
  font-size: 16px;
}
.contenter .time {
  text-align: center;
  margin-left: 200px;
  font-size: 12px;
  color: #444;
}
.contenter .title {
  height: 70px;
  width: 100%;
  /* border: 1px solid red; */
  line-height: 70px;
  font-size: 16px;
  font-weight: bold;
}
.contenter .title .el-icon-document {
  margin-right: 10px;
  font-size: 20px;
  /* line-height: 30px; */
  color: seagreen;
  font-weight: bold;
}
.contenter .des {
  background: #eef6f0;
  color: #555;
  line-height: 25px;
  padding: 15px 20px;
  font-size: 14px;
  text-indent: 30px;
}
.contenter .des1 {
  /* background: #eef6f0; */
  color: #555;
  line-height: 30px;
  padding: 15px 20px;
  font-size: 14px;
}
.contenter .textindent {
  text-indent: 30px;
}
.contenter .img {
  width: 100%;
  text-align: center;
}
.contenter .img1 {
  width: 100%;
  text-align: center;
  overflow: auto;
}
.contenter .img1 div{
  width: 80%;
  margin: 0 auto;
}
.contenter .img1 img{
  float: left;
  width: 50%;
}
.contenter .img {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 25px;
  overflow: auto;
  padding-bottom: 30px;
}
</style>
